import { Component, OnInit, Input, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { FilterGroupType, RuleOperator, FilterGroup, Filter } from 'src/app/modules/core/store/models/filters.model';
import { DocumentSchema, FieldDataType, SchemaField } from 'src/app/modules/core/store/models/document.model';
import { Workflow } from 'src/app/modules/core/store/models/workflow.model';
import { v4 as uuidv4 } from 'uuid';
import { Store } from '@ngrx/store';
import * as fromUserProfile from 'src/app/modules/core/store/user-profile';
import { filter, take } from 'rxjs/operators';
import { LinkFilter, LinkFilterGroup } from '../../../store/models/link-filters.model';
import { Dataset } from '../../../store/models/dataset.model';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'topo-link-filter-group',
    templateUrl: './filter-group.component.html',
    styleUrls: ['./filter-group.component.scss'],
    standalone: false
})
export class LinkFilterGroupComponent implements OnInit {
  @Input() set filterGroup(value: LinkFilterGroup) {
    if (!value) {
      this._filterGroup = null;
      return;
    }

    if (!value.uId) {
      value.uId = uuidv4();
    }

    for (let filter of value?.filters) {
      if (!filter.uId) {
        filter.uId = uuidv4();
      }
    }

    for (const filterGroup of value?.filterGroups) {
      if (!filterGroup.uId) {
        filterGroup.uId = uuidv4();
      }
    }

    this._filterGroup = value;
    if (!!!value.fromDatasetUId) {
      this._filterGroup.fromDatasetUId = this.datasets[0]?.uId;
    }

    this.toDatasetOrValue = !!value?.toDatasetUId ? 1 : 0;
    this.fromDatasetChanged();
    this.changeDetector.detectChanges();
  }
  _filterGroup: LinkFilterGroup;
  @Input() parentFilterGroup: LinkFilterGroup;
  @Input() level: number;
  @Input() workflow: Workflow;
  @Input() datasets: Dataset[];

  @Input() lookupTargetSchemaFields: SchemaField[];

  @Output() filterChanged: EventEmitter<LinkFilterGroup> = new EventEmitter<LinkFilterGroup>();

  nextLevel: number;
  spaces: number[];
  unitsConversionValue: number;
  toDatasetOrValue: number;
  fromDataset: Dataset;
  toDataset: Dataset;
  public SchemaDataType = FieldDataType;

  constructor(private store: Store<fromUserProfile.State>, private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.store
      .select(fromUserProfile.selectDistanceUnit)
      .pipe(take(1))
      .subscribe(unit => {
        if (unit?.toLocaleLowerCase() === 'miles') {
          this.unitsConversionValue = 1609;
        } else {
          this.unitsConversionValue = 1000;
        }
      });

    this.nextLevel = this.level + 1;
    this.spaces = Array(this.level)
      .fill(1)
      .map((x, i) => i);
  }

  sourceDatasetChanged(): void {}

  addFilterClick(): void {
    this._filterGroup.filters.push({
      uId: uuidv4(),
      fromSystemField: null,
      toSystemField: null,
      operator: RuleOperator.Equal,
      value: null,
      options: null
    });
    this.filterChanged.emit(this._filterGroup);
  }

  addFilterGroupClick(): void {
    this._filterGroup.filterGroups.push({
      uId: uuidv4(),
      filters: [],
      filterGroups: [],
      groupType: FilterGroupType.And,
      fromDatasetUId: this.datasets[0]?.uId,
      toDatasetUId: this.datasets[1]?.uId
    });
    this.filterChanged.emit(this._filterGroup);
  }

  addFilterGroupToParentClick(): void {
    if (!this.parentFilterGroup) {
      return;
    }

    this.parentFilterGroup.filterGroups.push({
      uId: uuidv4(),
      filters: [],
      filterGroups: [],
      groupType: FilterGroupType.And,
      fromDatasetUId: this.datasets[0]?.uId,
      toDatasetUId: this.datasets[1]?.uId
    });
  }

  deleteFilterGroupClick(): void {
    if (!this.parentFilterGroup) {
      return;
    }

    const index = this.parentFilterGroup.filterGroups.indexOf(this._filterGroup);
    this.parentFilterGroup.filterGroups.splice(index, 1);

    this.filterChanged.emit(this._filterGroup);
  }

  filterTrack(index, item: LinkFilter) {
    return item.uId;
  }

  filterGroupTrack(index, item: LinkFilterGroup) {
    return item.uId;
  }
  fromDatasetChanged(): void {
    this.fromDataset = this.datasets?.find(d => d.uId === this._filterGroup?.fromDatasetUId);
    this.toDataset = this.datasets[0]?.uId === this.datasets[1]?.uId ? this.fromDataset : this.datasets?.find(d => d.uId !== this._filterGroup?.fromDatasetUId);
    this._filterGroup.toDatasetUId = this.toDatasetOrValue == 1 ? this.toDataset.uId : null;

    this.filterChanged.emit(this._filterGroup);
  }

  toDatasetChanged(): void {
    this._filterGroup.toDatasetUId = this.toDatasetOrValue == 1 ? this.toDataset.uId : null;

    this.filterChanged.emit(this._filterGroup);
  }

  hasChildGroups(group: LinkFilterGroup): boolean {
    return (!!group?.filterGroups && group?.filterGroups.length > 0) &&
    (!!!group?.filters || group?.filters.length === 0)
  }

  onFilterChanged(filter: LinkFilter): void {
    this.filterChanged.emit(this._filterGroup);
  }
}
